import { RPerteChargeUniteCalculSchema_Type } from '@batical/types/src'
import { fetchGenericSorted, fetchGeneric } from './GenericQ'

const RPerteChargeUniteCalcul: Array<RPerteChargeUniteCalculSchema_Type> = require('../json/PerteChargeUnite.json')
export function fetchPerteChargeUniteSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(RPerteChargeUniteCalcul)
}

export function fetchPerteChargeUnite(uuid: string): RPerteChargeUniteCalculSchema_Type {
  return fetchGeneric(RPerteChargeUniteCalcul, uuid)
}
